import React from 'react';
import { Container, Row, Col, Card, ProgressBar } from 'react-bootstrap';
import ArrowRight from '../../assets/images/RightArrow.svg';
import Uparrow from '../../assets/images/Uparrow-Green.svg';
import Downarrow from '../../assets/images/DownArrow.svg';
import Active from '../../assets/images/Active.svg';
import Inactive from '../../assets/images/Inactive.svg';
import left from '../../assets/images/left.svg';
import right from '../../assets/images/right.svg';
import right1 from '../../assets/images/right1.svg';
import left1 from '../../assets/images/left1.svg';

import { Doughnut } from 'react-chartjs-2';

import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    ArcElement,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, ArcElement);

const SignageDashboard = () => {

    const percentage = 68;
    const totalApps = 24;
    const runningApps = 18;

    const total = 588;
    const embedded = 340;
    const duration = '30s';

    const activeDevices = 340;
    const inactiveDevices = 340;

    const activeData = [
        48, 5
    ];

    const inactiveData = [
        -20, -32
    ];

    const data = {
        labels: Array.from({ length: 30 }, (_, i) => `${i + 1}`),
        datasets: [
            {
                label: 'Active',
                data: activeData,
                backgroundColor: activeData.map((_, i) =>
                    i === activeData.length - 1 ? '#F1583C' : '#D4DDE7'
                ),
                hoverBackgroundColor: activeData.map((_, i) =>
                    i === activeData.length - 1 ? '#F1583C' : '#F1583C'
                ),
                borderRadius: 3,
            },
            {
                label: 'Inactive',
                data: inactiveData,
                backgroundColor: inactiveData.map((_, i) =>
                    i === inactiveData.length - 1 ? '#F4D25E' : '#D4DDE7'
                ),
                hoverBackgroundColor: inactiveData.map((_, i) =>
                    i === inactiveData.length - 1 ? '#F4D25E' : '#F4D25E'
                ),
                borderRadius: 3,
            }
        ]
    };


    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: { enabled: true }
        },
        scales: {
            x: {
                stacked: true,
                grid: { display: false },
                ticks: { display: false },
                border: { display: false }
            },
            y: {
                stacked: true,
                grid: {
                    display: true,
                    drawTicks: false,
                    color: (context) => {
                        return context.tick.value === 0 ? '#FFFFFF' : 'transparent';
                    }
                },
                border: { display: false },
                ticks: {
                    display: false,
                    beginAtZero: true
                }
            }
        }
    };

    // semicircularchart
    const embeddedLinks = 60;
    const widgets = 40;
    const sccTotal = embeddedLinks + widgets;


    const sccdata = {
        labels: ['Embedded Links', 'Widgets'],
        datasets: [
            {
                data: [embeddedLinks, widgets],
                backgroundColor: ['#F1583C', '#F4D25E'],
                borderWidth: 0,
                cutout: '60%',
                borderRadius: 0,
                spacing: 5
            },
        ],
    };

    const sccoptions = {
        rotation: -90,
        circumference: 180,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: true
            }
        },
    };

    // circular chart
    const ccdata = {
        datasets: [
            {
                data: [percentage, 100 - percentage],
                backgroundColor: ['#F1583C', '#eee'],
                borderWidth: 0,
                cutout: '70%',
            },
        ],
    };

    const ccoptions = {
        plugins: {
            tooltip: { enabled: false },
        },
        responsive: false,
        maintainAspectRatio: false,
    };



    return (
        <Container fluid className="px-0" style={{ backgroundColor: "#F5F7F9", paddingBottom: "10px", fontFamily: 'DMsans' }}>
            <Row className="px-4" style={{ padding: '10px' }}>
                <Col xs={12} style={{ padding: '20px', backgroundColor: '#FFFFFF', borderRadius: "16px", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                        <div style={{ fontSize: '24px', fontWeight: '500', color: '#21272C' }}>Signage overview</div>
                        <div style={{ fontSize: '15px', color: '#66737E', marginTop: '5px', fontWeight: 400 }}>Here you can see your overall signage overview and it's entire process in the single screen</div>
                    </div>
                    <div>
                        <select style={{
                            padding: '1px 16px', borderRadius: '62px', backgroundColor: "#F5F7F9", fontSize: "14px", fontWeight: 500, height: "40px", border: "none", appearance: 'none', backgroundImage: 'url("data:image/svg+xml;utf8,<svg fill=\'%23262626\' height=\'20\' viewBox=\'0 0 24 24\' width=\'20\' xmlns=\'http://www.w3.org/2000/svg\'><path d=\'M7 10l5 5 5-5z\'/></svg>")', backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center', backgroundSize: '14px', paddingRight: '36px'
                        }}>
                            <option value="all">This year</option>
                            <option value="gate1">This Month</option>
                            <option value="gate2">This Week</option>
                        </select>
                    </div>
                </Col>
            </Row>

            <Row className="" style={{ padding: '10px' }}>

                <Col xs={12} sm={6} md={2}>
                    <div style={{ backgroundColor: '#FFFFFF', padding: '20px', borderRadius: '16px', }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', }}>
                            <span style={{ width: "3px", height: "10px", backgroundColor: "#F1583C" }}></span>
                            <span style={{ color: '#000000', fontWeight: 400, fontSize: "16px" }}>Devices</span>
                            <span style={{ backgroundColor: '#F1FEF3', color: '#01B713', fontSize: '12px', fontWeight: 700, padding: '4px 10px', borderRadius: '35px' }}>
                                <img src={Uparrow} alt="Up Arrow" style={{ width: '12px', height: '12px', marginRight: '4px' }} />

                                <span>3.5%</span>
                            </span>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', fontSize: '36px', fontWeight: 500, color: '#000000', marginBottom: '8px', }}>
                            458
                            <img style={{ marginLeft: '15px', width: '34px', height: '34px', backgroundColor: "#F5F7F9", borderRadius: "50%", padding: "10px" }} src={ArrowRight} alt="Arrow Right" />
                        </div>

                        <div style={{ fontSize: '14px', color: '#66737E', fontWeight: 400 }}>
                            Last Update at 12:30 PM
                        </div>
                    </div>
                </Col>

                <Col xs={12} sm={6} md={2}>
                    <div style={{ backgroundColor: '#FFFFFF', padding: '20px', borderRadius: '16px', }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', }}>
                            <span style={{ width: "3px", height: "10px", backgroundColor: "#F1583C" }}></span>
                            <span style={{ color: '#000000', fontWeight: 400, fontSize: "16px" }}>Devices</span>
                            <span style={{ backgroundColor: '#FEF1F1', color: '#F1583C', fontSize: '12px', fontWeight: 700, padding: '4px 10px', borderRadius: '35px', display: 'flex', alignItems: 'center' }}>
                                <img src={Downarrow} alt="Down Arrow" style={{ width: '12px', height: '12px', marginRight: '4px' }} />
                                <span>2.5%</span>
                            </span>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', fontSize: '36px', fontWeight: 500, color: '#000000', marginBottom: '8px', }}>
                            458
                            <img style={{ marginLeft: '15px', width: '34px', height: '34px', backgroundColor: "#F5F7F9", borderRadius: "50%", padding: "10px" }} src={ArrowRight} alt="Arrow Right" />
                        </div>

                        <div style={{ fontSize: '14px', color: '#66737E', fontWeight: 400 }}>
                            Last Update at 12:30 PM
                        </div>
                    </div>
                </Col>

                <Col xs={12} sm={6} md={4}>
                    <div style={{ backgroundColor: '#FFFFFF', padding: '24px', borderRadius: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                        <div>
                            <div style={{ fontSize: "16px", fontWeight: 400, color: '#21272C', marginBottom: '12px' }}>
                                Running Internal Applications
                            </div>
                            <div style={{ fontSize: "36px", fontWeight: 500, color: '#000000', marginBottom: '12px' }}>
                                {runningApps}
                            </div>
                            <div style={{ fontSize: "14px", fontWeight: 400, color: '#66737E' }}>
                                Last Update at 12:30 PM
                            </div>
                        </div>

                        <div style={{ textAlign: 'center' }}>
                            <div style={{ width: 80, height: 80, position: 'relative' }}>
                                <Doughnut data={ccdata} options={ccoptions} width={80} height={80} />
                                <div style={{
                                    position: 'absolute',
                                    top: '60%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    fontSize: '16px',
                                    fontWeight: 500,
                                    color: '#21272C',
                                }}>
                                    {percentage}%
                                </div>
                            </div>
                            <div style={{
                                marginTop: '4px',
                                fontSize: '14px',
                                fontWeight: 400,
                                color: '#21272C',
                            }}>
                                <strong>{totalApps}</strong> applications
                            </div>
                        </div>
                    </div>
                </Col>

                <Col xs={12} sm={6} md={4}>
                    <div style={{ backgroundColor: '#FFFFFF', padding: '24px', borderRadius: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                        <div>
                            <div style={{ fontSize: "16px", fontWeight: 400, color: '#21272C', marginBottom: '12px' }}>
                                Running External Applications
                            </div>
                            <div style={{ fontSize: "36px", fontWeight: 500, color: '#000000', marginBottom: '12px' }}>
                                {runningApps}
                            </div>
                            <div style={{ fontSize: "14px", fontWeight: 400, color: '#66737E' }}>
                                Last Update at 12:30 PM
                            </div>
                        </div>

                        <div style={{ textAlign: 'center' }}>
                            <svg width="80" height="80" style={{ marginTop: "12px" }}>
                                <circle cx="40" cy="40" r="32" stroke="#eee" strokeWidth="8" fill="none" />
                                <circle cx="40" cy="40" r="32" stroke="#F1583C" strokeWidth="8" fill="none" strokeDasharray={2 * Math.PI * 32} strokeDashoffset={(1 - percentage / 100) * 2 * Math.PI * 32} strokeLinecap="round" transform="rotate(-90 40 40)" />
                                <text x="43" y="48" textAnchor="middle" fontSize="20" fontWeight="500" fill="#21272C">
                                    {percentage}%
                                </text>
                            </svg>
                            <div style={{ marginTop: '4px', fontSize: '14px', fontweight: 400, color: "#21272C" }}>
                                <strong>{totalApps}</strong> applications
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

            <Row className="" style={{ padding: '10px' }}>
                <Col lg={7}>
                    <div style={{ backgroundColor: '#FFFFFF', padding: '20px', borderRadius: '16px', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ fontWeight: '500', fontSize: '20px', marginBottom: '10px' }}>
                            External overview
                        </div>

                        <div style={{ padding: "16px", backgroundColor: "#F5F7F9", borderRadius: '40px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', backgroundColor: '#FFFFFF', borderRadius: '24px', padding: '10px' }}>
                                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                    <div style={{
                                        width: '150px',
                                        height: '90px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0 auto'
                                    }}>
                                        <Doughnut data={sccdata} options={sccoptions} />
                                    </div>


                                    <div style={{ marginTop: '-10px', fontSize: '24px', fontWeight: 600 }}>{total}</div>
                                    <div style={{
                                        fontSize: '14px',
                                        fontWeight: 400,
                                        color: '#666',
                                        borderBottom: "1px dashed #D4DDE7",
                                        marginBottom: '8px'
                                    }}>
                                        Total count
                                    </div>

                                    <div style={{
                                        marginTop: '12px',
                                        fontSize: '14px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'flex-start',
                                        gap: '6px'
                                    }}>
                                        <div>
                                            <span style={{
                                                width: '12px',
                                                height: '12px',
                                                backgroundColor: '#F1583C',
                                                borderRadius: '4px',
                                                marginRight: '8px',
                                                display: 'inline-block'
                                            }}></span>
                                            Embedded Links
                                        </div>
                                        <div>
                                            <span style={{
                                                width: '12px',
                                                height: '12px',
                                                backgroundColor: '#F4D25E',
                                                borderRadius: '4px',
                                                marginRight: '8px',
                                                display: 'inline-block'
                                            }}></span>
                                            Widgets
                                        </div>
                                    </div>
                                </div>


                                {/* Middle - Embedded Links */}
                                <div style={{ flex: 1, borderLeft: '1px solid #D4DDE7', paddingLeft: '16px' }}>
                                    <div style={{ fontWeight: 700, marginBottom: '8px', fontSize: "14px" }}>Embedded Links</div>
                                    <div style={{ fontSize: '32px', fontWeight: 500 }}>{embedded}</div>
                                    <div style={{ fontSize: '14px', color: '#66737E', marginBottom: '8px', fontWeight: 400 }}>
                                        Last Update at 12:30 PM
                                    </div>
                                    <div style={{ backgroundColor: '#F5F7F9', borderRadius: '100px', display: 'inline-block', padding: '4px 12px', fontSize: '14px', fontWeight: 500, color: '#21272C' }}>
                                        Duration <strong style={{ marginLeft: '6px' }}>{duration}</strong>
                                    </div>
                                </div>

                                {/* Right - Widgets */}
                                <div style={{ flex: 1, borderLeft: '1px solid #D4DDE7', paddingLeft: '16px' }}>
                                    <div style={{ fontWeight: 700, marginBottom: '8px', fontSize: "14px" }}>Widgets</div>
                                    <div style={{ fontSize: '32px', fontWeight: 500 }}>{widgets}</div>
                                    <div style={{ fontSize: '14px', color: '#66737E', marginBottom: '8px', fontWeight: 400 }}>
                                        Last Update at 12:30 PM
                                    </div>
                                    <div style={{ backgroundColor: '#F5F7F9', borderRadius: '100px', display: 'inline-block', padding: '4px 12px', fontSize: '14px', fontWeight: 500, color: '#21272C' }}>
                                        Duration <strong style={{ marginLeft: '6px' }}>{duration}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </Col>
                <Col lg={5}>
                    <div style={{ backgroundColor: '#FFFFFF', padding: '20px', borderRadius: '24px', margin: '0 auto', color: "#21272C" }}>
                        <div style={{ fontWeight: 500, fontSize: '20px', marginBottom: '10px' }}>
                            Devices status overview
                        </div>

                        <div style={{ display: 'flex', gap: '10px', marginBottom: '14px' }}>
                            {/* Active */}
                            <div style={{ backgroundColor: '#FFF2EF', borderRadius: '24px', flex: 1, padding: '10px', textAlign: 'center', position: 'relative' }}>
                                <div style={{
                                    display: "flex", justifyContent: "space-between", textAlign: 'center',
                                }}>
                                    <img src={left} alt="Active" />

                                    <div style={{ backgroundColor: '#F1583C', width: '40px', height: '40px', borderRadius: '50%', display: "flex", justifyContent: 'center', alignItems: "center", }}>
                                        <img src={Active} alt="Active" />
                                    </div>
                                    <img src={right} alt="Active" />
                                </div>

                                <div style={{ fontWeight: 400, fontSize: "14px" }}>Active devices</div>
                                <div style={{ fontSize: '28px', fontWeight: 500 }}>{activeDevices}</div>
                                <div style={{ fontSize: '12px', color: '#66737E', fontWeight: 400 }}>Last Update at 12:30 PM</div>


                            </div>

                            {/* Inactive */}
                            <div style={{ backgroundColor: '#FFFBEE', borderRadius: '20px', flex: 1, padding: '10px', textAlign: 'center', position: 'relative' }}>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <img src={left1} alt="Active" />

                                    <div style={{ backgroundColor: '#F4D25E', width: '40px', height: '40px', borderRadius: '50%', display: "flex", justifyContent: 'center', alignItems: "center" }}>
                                        <img src={Inactive} alt="Inactive" />
                                    </div>
                                    <img src={right1} alt="Inactive" />

                                </div>
                                <div style={{ fontWeight: 400, fontSize: "14px" }}>Inactive devices</div>
                                <div style={{ fontSize: '28px', fontWeight: 500 }}>{inactiveDevices}</div>
                                <div style={{ fontSize: '12px', color: '#66737E', fontWeight: 400 }}>Last Update at 12:30 PM</div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '10px' }}>

                            <div style={{ height: '80px', width: '80%', borderRight: '1px dashed #D4DDE7' }}>
                                <Bar data={data} options={options} />
                            </div>


                            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '0px', }}>
                                <div style={{ display: 'flex', alignItems: 'center', fontSize: '14px', marginBottom: '8px' }}>
                                    <div style={{ width: '12px', height: '12px', backgroundColor: '#F1583C', borderRadius: '4px', marginRight: '8px' }}></div>
                                    Active
                                    <div style={{ marginLeft: 'auto', fontWeight: 600 }}>62</div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}>
                                    <div style={{ width: '12px', height: '12px', backgroundColor: '#F4D25E', borderRadius: '4px', marginRight: '8px' }}></div>
                                    Inactive
                                    <div style={{ marginLeft: 'auto', fontWeight: 600 }}>32</div>
                                </div>
                                <div style={{ fontSize: '12px', color: '#888', marginTop: '8px' }}>
                                    On May 23, 2024
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default SignageDashboard;

